import type { QuerySnapshot } from "firebase/firestore";

export function createEntity(
  doc: { id: string },
  entity: Record<string, unknown> = {}
): Record<string, unknown> & { id: string } {
  return {
    id: doc.id,
    ...entity,
  };
}

export function snapshotToArray(
  snapshot: QuerySnapshot<unknown>
): Array<Record<string, unknown> & { id: string }> {
  const lst: Array<Record<string, unknown> & { id: string }> = [];
  snapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    // console.log(doc.id, " => ", doc.data());
    lst.push({
      ...(doc.data() as Record<string, unknown>),
      id: doc.id,
    });
  });
  return lst;
}
